module.exports = __webpack_public_path__ + "static/media/line-graph.9adaece4.svg";